const dataDocs = [
    {
        category: 'solicitacaoGuiaUpload',
        documents: [
            { id: 23, label: 'Solicitação de Guia' },
        ]
    },
    {
        category: 'docsComplementares',
        documents: [
            { id: 24, label: 'Documentos complementares' }
        ]
    }
];

export default dataDocs;